import { Avatar } from "antd";
import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { createBlogModal, setBlogPage } from "../../redux/actions/blogAction";
import { profileCharacters } from "../../utils/helper";
import { logout } from "../../redux/actions/authAction";
import { useAuthStore } from "../../store/AuthStore";

const Profile = (props) => {
  const history = useHistory();
  const { hasBlog, isPhysician, blogData, userData, mainBlogId } =
    useAuthStore();

  return (
    <>
      <div className="profile">
        <div
          className="head"
          onClick={() => {
            if (!isPhysician) {
              history.push({
                pathname: "/user/dashboard",
                state: { key: "bookmarked" },
              });
            } else if (hasBlog && isPhysician) {
              history.push(`/dashboard/${blogData.urlSlug}/my_posts`);
            }
          }}
        >
          <Avatar
            size={60}
            src={userData.profileImage}
            icon={profileCharacters(
              userData.firstName,
              userData.lastName ?? ""
            )}
            className="profile-img"
          />

          <div
            style={{ textAlign: "center" }}
            className="mt-2"
            onClick={() => {
              props.toggleMenu(false);
              props.toggleProfile();
            }}
          >
            <p className="title">
              {isPhysician && "Dr."} {userData.firstName}{" "}
              {userData.lastName ?? ""}
            </p>

            <p className="title">{userData.title}</p>
            <br />
          </div>
        </div>

        <div className="menu">
          {isPhysician && (
            <div className="submenu">
              {hasBlog ? (
                <>
                  <p
                    className="menu-title"
                    onClick={() =>
                      history.push(`/blogfolio/${blogData.urlSlug}/about`)
                    }
                  >
                    My Blog
                  </p>
                  {blogData.postCount > 0 ? (
                    <p
                      className="menu-title"
                      onClick={() =>
                        history.push(`/dashboard/${blogData.urlSlug}/my_posts`)
                      }
                    >
                      My Posts
                    </p>
                  ) : (
                    <>
                      <hr className="line mb-4" />

                      <button
                        className="create"
                        onClick={() =>
                          history.push(`/createPost/${mainBlogId}/post/new`)
                        }
                      >
                        + CREATE NEW POST
                      </button>

                      <hr className="line mb-4" />
                    </>
                  )}
                  <p
                    className="menu-title"
                    onClick={() =>
                      history.push(
                        `/dashboard/${blogData.urlSlug}/blogs_i_follow`
                      )
                    }
                  >
                    Blogs I Follow
                  </p>
                  <p
                    className="menu-title"
                    onClick={() =>
                      history.push(
                        `/dashboard/${blogData.urlSlug}/tags_i_follow`
                      )
                    }
                  >
                    Tags I Follow
                  </p>
                  <hr className="my-4" />
                </>
              ) : (
                <>
                  <button
                    className="create"
                    onClick={() => props.createBlogModal(true)}
                  >
                    + CREATE NEW BLOG
                  </button>

                  <hr className="line mb-4" />
                </>
              )}
            </div>
          )}

          {!isPhysician && (
            <div className="submenu">
              <p
                className="menu-title"
                onClick={() =>
                  history.push({
                    pathname: "/user/dashboard",
                    state: { key: "bookmarked" },
                  })
                }
              >
                Dashboard
              </p>
              <hr className="my-4" />
            </div>
          )}

          {isPhysician && (
            <div
              className="submenu"
              onClick={() => {
                window.open(
                  `https://www.dovemed.com/ratings/physician/${
                    blogData.author?.physicianId
                  }-${blogData.author?.firstName?.toLowerCase()}-${blogData.author?.lastName?.toLowerCase()}`,
                  "_self"
                );
              }}
            >
              <p className="menu-title">Go to DoveMed Profile</p>
            </div>
          )}

          <div className="text-center">
            <button
              onClick={() => {
                props.logout();
                localStorage.clear();
                props.history.push("/");
                window.location.reload();
              }}
              className="logout"
            >
              LOG OUT
            </button>
          </div>
        </div>
      </div>

      <style jsx="true">
        {`
          .profile {
            width: 310px;
            padding: 20px;
          }
          .head {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
          }
          .profile-img {
            border: 1px solid #ffffff;
            margin-right: 7px;
          }
          .title {
            color: #333333;
            font-family: Lato;
            font-size: 22px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 22px;
            margin-bottom: 0;
          }
          .menu-title {
            color: #333333;
            font-family: Lato;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 19px;
            margin-bottom: 30px;
          }
          .menu-title:hover {
            cursor: pointer;
          }
          .menu-title.disabled {
            color: #a0aec0;
          }
          .submenu-title {
            color: #333333;
            font-family: Lato;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 19px;
            margin-bottom: 30px;
            margin-left: 30px;
            position: relative;
          }
          .selected {
            font-weight: bold;
          }
          .selected::before {
            content: "✓";
            position: absolute;
            left: -20px;
            top: 0;
            color: #2a71d4;
          }
          .create {
            height: 35px;
            width: 240px;
            border-radius: 8px;
            background-color: #ffa405;
            color: #fff;
            font-family: Lato;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 17px;
            margin-bottom: 30px;
          }
          .line {
            margin-bottom: 30px;
          }
          .logout {
            height: 36px;
            width: 113px;
            border-radius: 22.5px;
            background-color: #2a71d4;
            color: #ffffff;
            font-family: Lato;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 17px;
          }
        `}
      </style>
    </>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  setBlogPage,
  createBlogModal,
  logout,
})(Profile);
